import React from 'react'
import Headroom from 'react-headroom'
import Link from '../../components/base/link'
import { fonts, colors, applicationStyles } from '../../themes'
import Grid from 'material-ui/Grid';
import LocationLinks from 'components/base/locationLinks'
import { fontFamilies } from 'themes/fonts'

const styles = {
  container: {
  },
  topContainer: {
    paddingTop: 20,
    paddingBottom: 20,
    backgroundColor: colors.green,
  },
  lowerContainer: {
    paddingTop: 20,
    paddingBottom: 20,
    backgroundColor: colors.green,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  link: {
    ...fontFamilies.lato,
    display: 'block',
    marginTop: 10,
  },
  title: {
    marginTop: 15,
    marginBottom: 5,
  }
}

const Footer = () => {
  return (
    <div css={styles.container}>
      <div css={styles.topContainer}>
        <div css={applicationStyles.mainTextContainer}>
          <Grid container spacing={24} style={{ flex: 1, display: 'flex' }}>
            <Grid item xs={12} sm={3}>
              <div style={styles.title}>Doctors</div>
              <Link style={styles.link} to='/forProviders'>For Providers</Link>
              <Link style={styles.link} to='/beta'>Doctor Signup</Link>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div style={styles.title}>Learn More</div>
              <Link style={styles.link} to='/blog'>Blog</Link>
              <Link style={styles.link} to='/faq'>FAQ</Link>
              <Link style={styles.link} to='/team'>Meet the Team</Link>
              <a css={styles.link} href='https://www.facebook.com/OnCallogyApp/'>Facebook</a>
              <a css={styles.link} href='https://twitter.com/oncallogy?lang=en'>Twitter</a>
              <a css={styles.link} href='https://www.instagram.com/oncallogy/'>Instagram</a>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div style={styles.title}>Employers</div>
              <Link style={styles.link} to='/forEmployers'>For Employers</Link>
              <Link style={styles.link} to='/employerSignup'>Employer Signup</Link>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div style={styles.title}>Legal</div>
              <Link style={styles.link} to='/privacyPolicy'>Privacy Policy</Link>
              <Link style={styles.link} to='/termsAndConditions'>Terms of Use</Link>
            </Grid>
          </Grid>
        </div>
      </div>
      <div css={styles.lowerContainer}>
        Copyright OnCallogy 2017
        <LocationLinks />
      </div>
    </div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/hybrid/footer.js